<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      @reload="getData"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main },
  props: {
    hxPreOrderCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
  },
  data() {
    return { loading: false, chooseAmzSkuVisible: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxPreOrderCode) return
      this.loading = true
      const res = await this.$api
        .ecomHxPreOrderDetailScmSummaryDetailListApi({
          hxPreOrderCode: this.hxPreOrderCode,
          scmCode: this.scmCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },
  },
}
</script>
